import React, { useMemo } from 'react';
import { useTabContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import { FDBox, FDStack } from '@facet-wealth/design';
import { RoadmapExplorerGoalsAccordion } from 'Components/UI/roadmapExplorer/goalsAccordion';

const GoalDetailsTabTemplate = () => {
  const { activeTabResource } = useTabContentContext();

  const goalsOnCurrentRoadmap = useMemo(() => {
    return (
      activeTabResource
        ?.attr('goals')
        ?.resources()
        ?.list?.() ?? []
    );
  }, [activeTabResource]);

  return (
    <FDBox paddingX={4} maxHeight={'100%'} height={'100%'}>
      <FDStack justifyContent="center" alignItems="center" flex={1} paddingY={2}>
        <FDStack justifyContent="center" alignItems="center" flex={1} overflow="auto">
          <RoadmapExplorerGoalsAccordion goals={goalsOnCurrentRoadmap} />
        </FDStack>
      </FDStack>
    </FDBox>
  );
};


GoalDetailsTabTemplate.propTypes = {};

export default GoalDetailsTabTemplate;
